<template>
  <div>
    <!-- 人脸识别组件 -->
    <el-dialog title="人脸识别" :visible.sync="cameraFalg" :close-on-click-modal="false">
      <div class="cameraBox">
        <div class="box2">需本人进行人脸认证核验后才能进行考试</div>
        <div style="" class="bkBox box3">
          <img v-if="showImg" :src="imgUrl" alt="" class="box5" />
          <video
            v-if="!showImg"
            ref="videoCamera"
            class="box23"
            id="videoCamera"
            :width="videoWidth"
            :height="videoHeight"
            autoplay
          ></video>
          <canvas id="canvasCamera" style="display: none" :width="videoWidth" :height="videoHeight"></canvas>
        </div>

        <div @click="setImage()" class="camerBtn">立即认证核验</div>
      </div>
    </el-dialog>

    <div class="classBnaer">
      <div class="classList" v-for="item in examList" :key="item.id">
        <div class="classImg">
          <div
            class="fm"
            style="position: relative; display: flex; justify-content: center; align-items: center; width: 125px; height: 97px"
          >
            <img
              style="position: absolute; top: 0; left: 0; z-index: 1; width: 100%; height: 100%; border-radius: 6px"
              src="../../../assets/indexImg/noimg.png"
              alt="安全生产学习平台"
            />
            <div
              style="
                font-size: 15px;
                font-family: kaiti;
                text-align: center;
                padding: 0 10px;
                font-weight: bold;
                color: #355fd9;
                position: relative;
                z-index: 2;
              "
            >
              {{ item.quizCodeName }}
            </div>
          </div>
        </div>
        <div class="classinfo">
          <div class="kcText_1">
            {{ item.quizCodeName }}
          </div>
            <div class="kcText_2">满分:100分</div>
            <div class="kcText_2" v-if="item.lrnExamQuiz">合格分数：{{ item.lrnExamQuiz.passscore }}分</div>
        </div>
        <div class="btn_1">
          <div class="btn_box" @click="gotoExam(item)">开始模拟考试</div>
        </div>
      </div>

      <div class="group_1">
        <div class="ksTitle">
          <img src="../../../assets/indexImg/icon_01.png" alt="" />
          <span>考试记录</span>
        </div>
        <div class="table">
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column type="index" label="序号" align="center"> </el-table-column>
            <el-table-column prop="grade" label="考试成绩" align="center"> </el-table-column>
            <el-table-column prop="state" label="试卷状态" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.state == '01'
                    ? '考试中'
                    : scope.row.state == '02'
                    ? '已保存'
                    : scope.row.state == '03'
                    ? '已交卷'
                    : scope.row.state == '04'
                    ? '批改中'
                    : '已批改'
                }}
              </template>
            </el-table-column>
            <el-table-column prop="answerDate" label="批卷时间" align="center"> </el-table-column>
            <el-table-column prop="quizName" label="所属试卷名称" align="center"> </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button @click="toPreview(scope.row.uqdId)">考卷回顾</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toMockExamQuiz, toExamUQDetailNew, getFaceConfig, compareAndSavePhoto } from '../../../api/study';
export default {
  components: {},
  data() {
    return {
      tableData: [],
      examList: [], //考试详情
      uqId: '',
      dialogVisible: false,
      cameraFalg: false,
      showImg: '',
      imgUrl: '',
      videoWidth: 470,
      videoHeight: 470,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      userphoto: '', //用户的头像。拿拍照的图片和头像对比是否本人
      learn_faceMatch_backstagePhoto_score: '' //分数
    };
  },

  computed: {},

  watch: {},

  methods: {
    //获取人脸识别参数
    getFaceConfig() {
      getFaceConfig().then(res => {
        this.captureCount = res.data.data.captureCount;
        this.alreadyPhotoCount = res.data.data.alreadyPhotoCount;
        this.faceConfigFlag = res.data.data.faceConfigFlag;
        this.intervalSeconds = res.data.data.intervalSeconds;
        this.userphoto = res.data.data.userPhoto; //头像
        this.learn_faceMatch_backstagePhoto_score = res.data.data.faceConfigScore; //分数
        if (this.userphoto == '') {
          this.$alert('该学习需要进行人脸识别，请先上传本人头像后再来学习！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$parent.nav(4);
            }
          });
          return false;
        }
        // if (res.data.data.alreadyPhotoCount >= parseInt(res.data.data.captureCount)) {
        //   this.cameraFalg = false;
        //   return false;
        // }
      });
    },
    // 调用权限（打开摄像头功能）
    async getCompetence() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.videoCamera.srcObject = stream;
      } catch (error) {
        this.$alert('无法访问摄像头!，请确认电脑摄像头功能正常后再来学习~', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$parent.nav(8);
          }
        });
      }
    },
    //  绘制图片（拍照功能）
    setImage() {
      let _this = this;
      let canvas = document.getElementById('canvasCamera');
      //相机截图工具
      _this.face_back_canvas = document.getElementById('canvasCamera');
      //截图内容
      _this.face_back_context = document.getElementById('canvasCamera').getContext('2d');
      try {
        let videow = document.getElementById('videoCamera').clientWidth;
        let videoh = document.getElementById('videoCamera').clientHeight;
        _this.face_back_canvas.setAttribute('width', videow);
        _this.face_back_canvas.setAttribute('height', videoh);
        _this.face_back_context.drawImage(document.getElementById('videoCamera'), 0, 0, videow, videoh);
        _this.face_back_base64Photo = canvas.toDataURL('image/jpeg', 1);
        _this.showImg = true;
        _this.imgUrl = _this.face_back_base64Photo;
        _this.carmerShow = false;
        let data = {
          photoType: 'learn_facaMatch_backstagePhoto_pc',
          photoWay: 'photo_way_facaMatch',
          userphoto: _this.userphoto,
          base64Photo: _this.face_back_base64Photo,
          learn_faceMatch_backstagePhoto_score: _this.learn_faceMatch_backstagePhoto_score,
          userQuizId: this.uqId
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 10000);
        compareAndSavePhoto(data).then(res => {
          console.log(res.data.data.isPhotoCountFull);
          loading.close();
          if (res.data.data.isPassFlag) {
            //通过
            _this.$message({
              message: res.data.data.msg,
              type: 'success'
            });
            _this.$router.push({
              path: '/questions',
              query: {
                id: _this.uqId,
                classId: _this.$route.query.classId
              }
            });
          } else {
            _this.$message.error(res.data.data.faceMatchResult);
            setTimeout(() => {
              _this.showImg = false;
              _this.imgUrl = '';
              _this.face_back_base64Photo = '';
              _this.getCompetence();
            }, 1000);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    //考卷回顾
    toPreview(uqdId) {
      window.open(this.$router.resolve({ path: '/record?id='+uqdId+'&classId='+ this.$route.query.classId+'&type=mo'}).href, '_blank');
    },
    //返回
    goBack() {
      this.$router.push({ path: '/studyMain', query: { tabIndex: 10 } });
      this.$parent.nav(10);
    },
    //获取考试详情
    getExam() {
      toMockExamQuiz().then(res => {
        console.log(res);
        this.examList = res.data.data.examUqList;
      });
    },
    //去参加考试
    gotoExam(item) {
      window.open(this.$router.resolve({ path: '/mnExam?uqId='+item.id+'&uqdId='+ item.uqdId}).href, '_blank');
      
    },
    //获取考试记录
    toExamUQDetailNew() {
      toExamUQDetailNew().then(res => {
        console.log(res.data.data);
        this.tableData = res.data.data;
      });
    }
  },

  created() {
    this.getExam();
    this.toExamUQDetailNew();
  },

  mounted() {},
  beforeCreate() {},
  beforeMount() {}
};
</script>
<style lang="less" scoped>
.cameraBox {
  padding: 0 25px;
  font-family: Medium;
  font-size: 16px;
  .bkBox {
    display: flex;
    justify-content: center;
    position: relative;
    .bk {
      position: absolute;
      top: 0;
      left: 0;
    }
    .box5 {
      margin-top: 10px;
    }
  }
  .camerBtn {
    width: 180px;
    height: 50px;
    background: #4275f5;
    opacity: 1;
    border-radius: 25px;
    font-family: Medium;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    margin: 28px auto auto auto;
  }
}
.classBnaer {
  width: 1170px;
  background: #fff;
  padding: 20px;
  min-height: 660px;
  border-radius: 6px;
  .classList {
    width: 100%;
    height: 150px;
    border-bottom: 1px #ccc solid;
    display: flex;
    align-items: center;
    .classImg {
      img {
        width: 150px;
        height: 110px;
      }
    }
    .classinfo {
      margin-left: 20px;
      .kcText_1 {
        font-size: 20px;
        width: 500px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .kcText_2 {
        margin-top: 8px;
      }
      .score {
        color: #cd6e6d;
        margin-top: 8px;
      }
    }
    .btn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #888888;
      border: 1px solid #888888;
      border-radius: 3px;
      margin-left: 150px;
      cursor: pointer;
    }
  }
}
.btn_1 {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn_box {
    font-size: 20px;
    border: 1px solid #2878ff !important;
    color: #2878ff !important;
    width: 180px;
    height: 40px;
    text-align: center;
    border-radius: 5px;
    line-height: 40px;
    cursor: pointer;
  }
}
.group_1 {
  margin-top: 50px;
  .ksTitle {
    display: flex;
    align-items: center;
    font-size: 18px;

    img {
      width: 6px;
      height: 19px;
      margin-right: 5px;
    }
  }
  .table {
    margin-top: 20px;
    ::v-deep {
      .has-gutter {
        th {
          background: #7dbee8;
          color: #fff;
        }
      }
    }
  }
}
.btn_4 {
  display: flex;
  justify-content: center;
  .btn_5 {
    background: #3f76c0;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    width: 98px;
    text-align: center;
    height: 30px;
    color: #fff;
    line-height: 30px;
    border-radius: 5px;
    margin-top: 20px;
  }
}
</style>
